import {
  Box,
  Button,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CommonTable from "../../common/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import customerActions from "../../redux/customer/actions";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import masterActions from "../../redux/master/actions";
import * as XLSX from "xlsx";

export default function Index() {
  const dispatch = useDispatch();
  const [courseid, setCourseId] = useState(0);
  const [rollNo, setRollNo] = useState("");

  const { courseList } = useSelector((state) => state.masterReducer);
  const { objectionPayments } = useSelector((state) => state.customerReducer);
  const [courseError, setCourseError] = useState("");

  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
   
  }, []);

  const onChangeCourse = (e) => {
    setCourseId(e.target.value);
    setCourseError("");
  };

  const handleRollNoChange = (e) => {
    setRollNo(e.target.value);
  };

  const handleGenerate = () => {
    if (courseid === 0) {
      setCourseError("Course is required");
      return;
    }

    dispatch({
      type: customerActions.GET_OBJECTION_PAYMENT_REPORT,
      payload: { courseid: courseid, rollno: rollNo },
    });
  };

  const handleDownloadExcel = () => {
    if (!objectionPayments || objectionPayments.length === 0) return;

    const data = objectionPayments.map((item) => ({
      "Sr.No": objectionPayments.indexOf(item) + 1,
      "Candidate Roll No": item?.rollno ?? "N/A",
      "Application No": item?.application_no ?? "N/A",
      "Candidate Name": item?.candidate_name ?? "N/A",
      "Exam Name": item?.exam_name ?? "N/A",
      "Exam Date": item?.exam_date
        ? new Date(item.exam_date).toLocaleDateString("en-GB")
        : "N/A",
      "Question ID": item?.question_id ?? "N/A",
      "Objection Status": item?.objection_status ?? "N/A",
      "Payment Status": item?.payment_status ?? "N/A",
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Objection Payment Report");

    const wscols = [
      { wch: 10 }, 
      { wch: 20 }, 
      { wch: 20 }, 
      { wch: 20 }, 
      { wch: 20 }, 
      { wch: 10 }, 
      { wch: 15 }, 
      { wch: 15 },
    ];
    worksheet["!cols"] = wscols;

    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const address = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!worksheet[address]) continue;
      worksheet[address].s = {
        font: { bold: true },
        alignment: { horizontal: "center", vertical: "center" },
      };
    }

    XLSX.writeFile(workbook, "Objection Payment Report.xlsx");
  };

  let applicationStatusColumns = [
    { name: "Sr.No", dataIndex: "srNo" },
    { name: "Candidate Roll No", dataIndex: "rollno" },
    { name: "Application No", dataIndex: "application_no" },
    { name: "Candidate Name", dataIndex: "candidate_name" },
    { name: "Exam Name", dataIndex: "exam_name" },
    { name: "Exam Date", dataIndex: "exam_date" },
    { name: "Question ID", dataIndex: "question_id" },
    { name: "Objection Status", dataIndex: "objection_status" },
    { name: "Payment Status", dataIndex: "payment_status" },
  ];
  
  const tableData = Array.isArray(objectionPayments)
  ? objectionPayments.map((item, index) => ({
      srNo: index + 1,
      application_no: item?.application_no ?? "N/A",
      candidate_name: item?.candidate_name ?? "N/A",
      exam_name: item?.exam_name ?? "N/A",
      exam_date: item?.exam_date
      ? new Date(item.exam_date).toLocaleDateString("en-GB")
      : "N/A",
      question_id: item?.question_id ?? "N/A",
      objection_status: item?.objection_status ?? "N/A",
      payment_status: item?.payment_status ?? "N/A",
      rollno: item?.rollno ?? "N/A",
    }))
  : [];


  return (
    <>
      <Box
        sx={{
          margin: "1rem auto",
          backgroundColor: "rgba(255, 255, 255, 1)",
          borderRadius: "8px",
          padding: "10px",
        }}
      >
        <Card sx={{ p: 2 }}>
          <Typography>Objection Payment  Report </Typography>

          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl error={!!courseError} sx={{ width: "100%" }}>
                <Select
                  size="small"
                  onChange={onChangeCourse}
                  value={courseid}
                  defaultValue={0}
                  sx={{ height: "56px" }}
                >
                  <MenuItem value={0} selected>
                    Select Course <span style={{ color: "red" }}>*</span>
                  </MenuItem>
                  {courseList?.all
                    ?.filter((course) => course.isactive === "1")
                    .map((course, i) => (
                      <MenuItem key={i} value={course.courseid}>
                        {course.coursename}
                      </MenuItem>
                    ))}
                </Select>
                {courseError && (
                  <Typography variant="caption" color="error">
                    {courseError}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl sx={{ width: "100%" }} variant="outlined">
                <InputLabel htmlFor="search-roll-no">
                  Search by Roll No
                </InputLabel>
                <OutlinedInput
                  id="search-roll-no"
                  value={rollNo}
                  onChange={handleRollNoChange}
                  label="Search by Roll No"
                />
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              mt={1}
              sx={{ display: "flex", gap: 1 }}
            >
              <Box sx={{ marginTop: { xs: 2, sm: 0 } }}>
                <BluePrimaryButton
                  title={"Generate Report"}
                  handleSubmit={handleGenerate}
                />
              </Box>
              <Button
                onClick={handleDownloadExcel}
                sx={{
                  backgroundColor: "green",
                  color: "white",
                  height: "40px",
                  borderRadius: "11px",
                  "&:hover": { backgroundColor: "darkgreen" },
                }}
              >
                Download Excel
              </Button>
            </Grid>
          </Grid>

       
          <CommonTable
            columnData={applicationStatusColumns}
            tableData={tableData}
          />
        </Card>
      </Box>
    </>
  );
}
